import Dialog from "../components/dialog.vue";

function CreateDialog(Vue, options) {
  const { component, params, config } = options;

  if (!component) {
    return;
  }

  const DialogClass = Vue.extend({
    render(h) {
      return h(
        Dialog,
        {
          props: {
            ...config,
            close,
          },
        },
        [h(component, { props: params })]
      );
    },
  });
  const $vm = new DialogClass({
    el: document.createElement("div"),
  });
  document.body.appendChild($vm.$el);

  function close() {
    document.body.removeChild($vm.$el);
  }
}

export default {
  install(Vue) {
    Vue.prototype.$dialog = function (options) {
      CreateDialog(Vue, options);
    };
  },
};
